import * as React from 'react';

import { cn } from '@/utils/cn';

export const Page = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ className, ...props }, ref) => (
        <div
            ref={ref}
            className={cn('flex h-full w-full min-w-[850px] flex-col overflow-hidden bg-white', className)}
            {...props}
        />
    ),
);
Page.displayName = 'Page';
